<template>
  <div class="golditems">
    <div class="header header-golddetail">
      <div class="back-btn new address">
        <img src="../assets/images/arrow-w.svg" @click="goBack()" />
       </div>
      <h2>{{$t('gold')}}91</h2>
    </div>
    <div class="container container-golddetail">
      <div class="product-wrapper">
        <GoldProductDetails :goldProductDescr="goldItemDetails" />
        <div class="free-ship-block">
          <div class="free-ship">
            <img src="../assets/images/free-delivery_icon.svg" />
            <span>{{$t('freeshipping')}}</span>
          </div>
        </div>
        <div class="custom_delivery">
          <div class="address-text">{{$t('address_delivery')}}</div>
          <div class="delivery-address-section">
            <div
              class="address-fill select-add"
              v-for="(item,index) in  useraddress_list"
              :key="index"
            >
              <label class="radio-group radio-btn-add">
                <span>
                  {{item.customer_name}},
                  {{item.house_no}},{{item.street}},
                  {{item.landmark}},
                  {{item.city}} {{item.state}}- {{item.pincode}}
                </span>
                <input type="radio" name="address" v-model="deliver_address" :value="item.id" />
                <span class="circle"></span>
              </label>
            </div>
            <Button
              class="button new-address-btn"
              @addNewAddress="createAddress"
              :btn_txt="$t('new_address')"
            ></Button>
          </div>
        </div>
        <PurchaseTandC />
      </div>
    </div>
    <div class="submit-btn-block">
      <Button
        v-if="goldItemDetails.minting_cost"
        class="button"
        @paymentDetails="paydetail()"
        :btn_txt="$t('buybuttontxt' ,  {mintingcost:goldItemDetails.minting_cost})"
      ></Button>
    </div>
    <div v-if="!showPopup" class="popoverlaybg">
      <Popup :product="goldItemDetails" />
    </div>
    <div class="loader" v-if="loading">
      <img src="https://cdn.mall91.com/9ca91a3c-b750-4f95-854b-15588473cc97.gif" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Button from "../components/Button";
import GoldProductDetails from "../components/GoldProductDetails";
import PurchaseTandC from "../components/PurchaseTandC";
import { toaster } from "../utils/helper";
import { SessionHelper } from "../utils/session"
import Popup from "../components/Popup";
import AddNewAddress from "../components/AddNewAddress";

export default {
  computed: {
    ...mapGetters(["user", "isUserAuthorized"])
  },
  name: "GoldProductWrapper",
  components: {
    Button,
    GoldProductDetails,
    PurchaseTandC,
    Popup,
    AddNewAddress
  },
  data() {
    return {
      productDetails: {},
      address_list: [],
      useraddress_list: [],
      goldItemDetails: {},
      loading: false,
      paymentVerfication: {},
      showPopup: true,
      deliver_address: this.useraddress_list && this.useraddress_list[0].id
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    paydetail() {
      if (!this.isUserAuthorized) {
        toaster(this, this.$t("notauthorised"), "top-left", 2000);
        return;
      }
      const { is_registered } = this.user;
      if (!is_registered) {
        toaster(this, this.$t("notregistered"), "top-left", 3000);
        this.$router.push("/registration");
        return;
      }
      if (this.user.total_gold_amount < this.goldItemDetails.metal_weight) {
        this.showPopup = !this.showPopup;
        document.body.classList.add("customModelpop");
        return;
      }
      SessionHelper.refereshJwtToken()
      this.$store
        .dispatch({
          type: "deliveryVerification",
          payload: {
            address_id: this.deliver_address,
            product_id: Number(this.goldItemDetails.product_id)
          }
        })
        .then(data => {
          SessionHelper.setCookie(
            "_goldTransactionInfo",
            JSON.stringify(Object.assign(data.data.data, this.goldItemDetails))
          );
          this.$router.push({
            path: "/purchase-payment"
          });
        })
        .catch(err => {
          toaster(this, this.$t("somethinawaitgwentwrong"), "top-left", 2000);
        });
    },

    createAddress() {
      this.$router.push("/new-address");
    },

    goldproductDetail() {
      this.loading = !this.loading;
      this.$store
        .dispatch({
          type: "deliveryProductDetail",
          payload: this.$route.params.id
        })
        .then(data => {
          this.loading = !this.loading;
          this.goldItemDetails = data.data;
        })
        .catch(err => {
          this.loading = !this.loading;
          toaster(this, this.$t("somethingwentwrong"), "top-left", 2000);
        });
    }
  },

  async mounted() {
    this.goldproductDetail();
    await this.$store
      .dispatch({ type: "userAddressDetail" })
      .then(data => {
        this.useraddress_list = data.data.address;
        if (data.data.address.length) {
          this.deliver_address = data.data.address[0].id
          }
      })
      .catch(err => {
        toaster(this, this.$t("somethingwentwrong"), "top-left", 2000);
      });
  }
};
</script>